import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=710087ab&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=710087ab&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "710087ab",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/test-crmeb-admin-front-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('710087ab')) {
      api.createRecord('710087ab', component.options)
    } else {
      api.reload('710087ab', component.options)
    }
    module.hot.accept("./editor.vue?vue&type=template&id=710087ab&scoped=true", function () {
      api.rerender('710087ab', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rsManagement/receiptTemplate/editor.vue"
export default component.exports